import { isValidUsername, isValidAccount, isValidPhoneNumber, isName } from './validate'

export interface Validator {
  (rule: any, value: string, callback: any): void
}

export const oddsValidator = (rule: any, value: any, callback: any) => {
  if (value.odds === '') {
    callback(new Error('不能为空'))
  } else {
    const oddsValue = Number(value.odds)
    const oddsStr = String(value.odds)
    if (oddsStr.match(/[^0-9.]+/)) {
      callback(new Error('含有无效字符'))
    } else if (!oddsStr.match(/^[1-9]\d*(\.\d{0,3})?$/) || oddsValue <= 1) {
      callback(new Error('输入的值无效，必须大于1，且最多3位小数'))
    } else if (oddsValue > 99999) {
      callback(new Error('输入的值过大，请重新输入'))
    } else if (!isNaN(value.limit) && oddsValue > value.limit) {
      callback(new Error(`输入的值不能大于上级设置的赔率${value.limit}`))
    } else {
      callback()
    }
  }
  callback()
}

export const numberValidator = (rule: any, value: string, callback: any) => {
  const num = Number(value)
  if (isNaN(num)) {
    callback(Error('请输入正确的数值'))
  }
  callback()
}

/** 正数 */
export const positiveNumberValidator = (rule: any, value: string, callback: any) => {
  const num = Number(value)
  if (isNaN(num)) {
    callback(Error('请输入正确的数值'))
  } else if (num <= 0) {
    callback(Error('输入的数必须大于0'))
  }
  callback()
}

/** 不能为负数 */
export const notNegativeNumberValidator = (rule: any, value: string, callback: any) => {
  const num = Number(value)
  if (isNaN(num)) {
    callback(Error('请输入正确的数值'))
  } else if (num < 0) {
    callback(Error('不能为负数'))
  }
  callback()
}

export const percentPrecision1Validator = (rule: any, value: any, callback: Function) => {
  const valueStr = value || ''
  const valueNum = Number(value)
  if (!valueStr.match(/^[1-9]?\d*(\.\d{0,1})?$/)) {
    callback(new Error('最多只能1位小数'))
  } else if (valueNum < 0 || valueNum > 100) {
    callback(new Error('输入的范围无效，应该在0-100内'))
  }
  callback()
}

export const usernameValidator = (rule: any, value: string, callback: any) => {
  if (!isValidUsername(value)) {
    callback(new Error('用户名长度应该为2-20'))
  } else {
    callback()
  }
}
export const nameValidator = (rule: any, value: string, callback: any) => {
  if (!isName(value)) {
    callback(new Error('姓名格式不正确'))
  } else {
    callback()
  }
}
export const partValidator = (rule: any, value: string, callback: any) => {
  if (value === '') {
    callback(new Error('部门名称不能为空'))
  } else if (!isName(value)) {
    callback(new Error('部门名称长度为2-10个字符'))
  } else {
    callback()
  }
}
export const accountValidator = (rule: any, value: string, callback: any) => {
  if (!isValidAccount(value)) {
    callback(new Error('账号长度应该为4-25，且只能包含大小写字母数字以及下划线'))
  } else {
    callback()
  }
}

export const passwordValidator = (rule: any, value: string, callback: any) => {
  if (!value || value.length < 6) {
    callback(new Error('密码不能小于6位'))
  } else {
    callback()
  }
}

export const checkPasswordValidator = (checkPsw: () => String) => {
  return (rule: any, value: string, callback: any) => {
    if (!value || value.length < 6) {
      callback(new Error('密码不能小于6位'))
    } else if (value !== checkPsw()) {
      callback(new Error('两次密码输入不一致'))
    } else {
      callback()
    }
  }
}
export const checkCodeValidator = (checkCode: () => String) => {
  return (rule: any, value: string, callback: any) => {
    if (!value || value.length < 4) {
      callback(new Error('请输入四位验证码'))
    } else if (value.toUpperCase() !== checkCode().toUpperCase()) {
      callback(new Error('验证码错误'))
    } else {
      callback()
    }
  }
}

export function exchangePasswordValidator(rule: any, value: string, callback: any) {
  if (value.match(/^[a-zA-Z0-9]{6,18}$/) === null) {
    callback(new Error('密码为6到18个英文字母或数字组成'))
  } else if (value.match(/^([a-zA-Z]{6,18})$|^([0-9]{6,18})$/) !== null) {
    callback(new Error('密码过于简单，请不要使用纯数字或常用密码'))
  } else {
    callback()
  }
}

export const phoneNumberValidator = (rule: any, value: string, callback: any) => {
  if (isValidPhoneNumber(value)) {
    callback()
  }
  callback(new Error('手机号码格式不正确'))
}

export const vertificatiionCodeValidator = (rule: any, value: string, callback: any) => {
  if (value.match(/^\d{6}$/) !== null) {
    callback()
  }
  callback(new Error('验证码格式错误，应为6位数字'))
}

export function createNumberWithRangeValidator(minGetter: () => number, maxGetter: () => number) {
  return (rule: any, value: string, callback: any) => {
    const valueNum: number = Number(value)
    if (minGetter) {
      const min: number = minGetter()
      if (valueNum < min) {
        callback(new Error('不能小于最小值：' + min))
      }
    }
    if (maxGetter) {
      const max: number = maxGetter()
      if (valueNum > max) {
        callback(new Error('不能大于最大值：' + max))
      }
    }
    callback()
  }
}

export function numberLimitValidator(precision: number = 2) {
  return (rule: any, value: string, callback: any) => {
    const regStr = `^-?([1-9]([0-9]+)?|0)(\\.\\d{1,${precision}})?$`
    const reg = new RegExp(regStr)
    if (!value.match(reg)) {
      callback(new Error(`请输入正确的数值,最多${precision}位小数`))
    } else {
      callback()
    }
  }
}

export const currencyPairsValidator = (rule: any, value: string, callback: any) => {
  if (value && value.match(/^[0-9a-zA-Z]{1,8}\/[0-9a-zA-Z]{1,8}$/)) {
    callback()
  }
  callback(new Error('格式有误，示例：XXX/YYY' as string))
}
